// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__P-joh","opacity-transition":"success_opacity-transition__F348o"};